// extracted by mini-css-extract-plugin
export default {"login_wrapper":"Login_login_wrapper__TLFoG","login_form":"Login_login_form__xxYqg","login_welcome":"Login_login_welcome__J1Ap+"};